type CalcAProofResult = {
    /**
     * ステータス
     * @type {string}
     * @memberof CalcAProofResult
     */
    status?: string;
    /**
     * メッセージ
     * @type {string}
     * @memberof CalcAProofResult
     */
    message?: string;
    /**
     * モード
     * @type {number}
     * @memberof CalcAProofResult
     */
    calculationMode?: CalcMode;
    /**
     * 槽の情報
     * @type {Array<AProofElectrolyzer>}
     * @memberof CalcAProofResult
     */
    electroyzerList?: Array<AProofElectrolyzer>;
    /**
     * 計算結果
     * @type {ResultAProof}
     * @memberof CalcAProofResult
     */
    result?: ResultAProof;
}

type CalcMode = {
    /**
     * 計算モード
     * @type {string}
     * @memberof CalcMode
     */
    mode?: string;
    /**
     * NaOH生産量
     * @type {number}
     * @memberof CalcAProofResult
     */
    targetNaoh?: number;
    /**
     * CCl2生産量
     * @type {number}
     * @memberof CalcAProofResult
     */
    targetCl2?: number;
    /**
     * CCl2生産量
     * @type {number}
     * @memberof CalcAProofResult
     */
    cl2Efficiency?: number;
}


type AProofUnitInput = {
    /**
     * 槽の番号
     * @type {number}
     * @memberof AProofUnitInput
     */
    no?: number;
    /**
     * electrolyzer
     * @type {string}
     * @memberof AProofUnitInput
     */
    electrolyzer?: string;
    /**
     * 稼働/停止
     * @type {number}
     * @memberof AProofUnitInput
     */
    operate?: string;
    /**
     * 対数
     * @type {number}
     * @memberof AProofUnitInput
     */
    cells?: number;
    /**
     * 実運用ー電流
     * @type {number}
     * @memberof AProofUnitInput
     */
    current?: number;
    /**
     * 実運用ー電圧
     * @type {number}
     * @memberof AProofUnitInput
     */
    voltage?: number;
    /**
     * 実運用ーNaOH温度
     * @type {number}
     * @memberof AProofUnitInput
     */
    temp?: number;
    /**
     * 電流効率
     * @type {number}
     * @memberof AProofUnitInput
     */
    currentEfficiency?: number;
    /**
     * 電流最大
     * @type {number}
     * @memberof AProofUnitInput
     */
    rangeMax?: number;
    /**
     * 電流最小
     * @type {number}
     * @memberof AProofUnitInput
     */
    rangeMin?: number;
    /**
     * NaOH生産量
     * @type {number}
     * @memberof AProofUnitInput
     */
    naohProduction?: number;
    /**
     * 50% NaOH 中の推定 NaCl
     * @type {number}
     * @memberof AProofUnitInput
     */
    naclInNaoh50?: number;
    /**
     * PC
     * @type {number}
     * @memberof AProofUnitInput
     */
    pc?: number;
}

type AProofUnitOutput = {
    /**
     * 槽の番号
     * @type {number}
     * @memberof AProofUnitInput
     */
    no?: number;
    /**
     * electrolyzer
     * @type {string}
     * @memberof AProofUnitInput
     */
    electrolyzer?: string;
    /**
     * 稼働/停止
     * @type {number}
     * @memberof AProofUnitInput
     */
    operate?: string;
    /**
     * 最適化後電流
     * @type {number}
     * @memberof AProofUnitOutput
     */
    optimizedCurrent?: number;
    /**
     * 電圧
     * @type {number}
     * @memberof AProofUnitOutput
     */
    voltage?: number;
    /**
     * NaOH温度
     * @type {number}
     * @memberof AProofUnitOutput
     */
    temp?: number;
    /**
     * PC
     * @type {number}
     * @memberof AProofUnitOutput
     */
    pc?: number;
    /**
     * NaOH生産量
     * @type {number}
     * @memberof AProofUnitOutput
     */
    naohProduction?: number;
    /**
     * 50% NaOH 中の推定 NaCl
     * @type {number}
     * @memberof AProofUnitOutput
     */
    naclInNaoh50?: number;
}

type AProofElectrolyzer = {
    /**
     * 入力情報
     * @type {AProofUnitInput}
     * @memberof CalcAProofResult
     */
    input?: AProofUnitInput;
    /**
     * 出力情報
     * @type {AProofUnitOutput}
     * @memberof CalcAProofResult
     */
    output?: AProofUnitOutput;
}

type ResultCalcAp = {
    /**
     * 計算結果区分
     * @type {string}
     * @memberof ResultCalcAp
     */
    resultClass?: string;
    /**
     * 苛性生産量
     * @type {number}
     * @memberof ResultCalcAp
     */
    naohProduction?: number;
    /**
     * 塩素生産量
     * @type {number}
     * @memberof ResultCalcAp
     */
    cl2Production?: number;
    /**
     * 苛性50%中食塩濃度
     * @type {number}
     * @memberof ResultCalcAp
     */
    naclInNaoh50?: number;
    /**
     * 苛性32%中食塩濃度
     * @type {number}
     * @memberof ResultCalcAp
     */
    naclInNaoh32?: number;
    /**
     * 電力
     * @type {number}
     * @memberof ResultCalcAp
     */
    power?: number;
}

type ApImprovement = {
    /**
     * 比較対象の計算結果区分
     * @type {string}
     * @memberof ApImprovement
     */
    vsClass?: string;
    /**
     * 効果
     * @type {number}
     * @memberof ApImprovement
     */
    improvement?: number;
}

type ResultAProof = {
    /**
     * 計算結果一覧
     * @type {Array<ResultCalcAp>}
     * @memberof ResultAp
     */
    resultList?: Array<ResultCalcAp>;
    /**
     * 効果一覧
     * @type {Array<ApImprovement>}
     * @memberof ResultAp
     */
    improvementList?: Array<ApImprovement>;
}


export type {CalcAProofResult}
export type {AProofElectrolyzer}

export const CalcAProofResultDefaultData: CalcAProofResult = {
    status: "",
    message: "",
    calculationMode: {},
    electroyzerList: [
        { input:{ no: 1, operate: "Stop" }, output:{ no: 1, operate: "Stop" } },
        { input:{ no: 2, operate: "Stop" }, output:{ no: 2, operate: "Stop" } },
        { input:{ no: 3, operate: "Stop" }, output:{ no: 3, operate: "Stop" } },
        { input:{ no: 4, operate: "Stop" }, output:{ no: 4, operate: "Stop" } },
        { input:{ no: 5, operate: "Stop" }, output:{ no: 5, operate: "Stop" } },
        { input:{ no: 6, operate: "Stop" }, output:{ no: 6, operate: "Stop" } },
        { input:{ no: 7, operate: "Stop" }, output:{ no: 7, operate: "Stop" } },
        { input:{ no: 8, operate: "Stop" }, output:{ no: 8, operate: "Stop" } },
        { input:{ no: 9, operate: "Stop" }, output:{ no: 9, operate: "Stop" } },
        { input:{ no: 10, operate: "Stop" }, output:{ no: 10, operate: "Stop" } },
        { input:{ no: 11, operate: "Stop" }, output:{ no: 11, operate: "Stop" } },
        { input:{ no: 12, operate: "Stop" }, output:{ no: 12, operate: "Stop" } },
        { input:{ no: 13, operate: "Stop" }, output:{ no: 13, operate: "Stop" } },
        { input:{ no: 14, operate: "Stop" }, output:{ no: 14, operate: "Stop" } },
        { input:{ no: 15, operate: "Stop" }, output:{ no: 15, operate: "Stop" } },
        { input:{ no: 16, operate: "Stop" }, output:{ no: 16, operate: "Stop" } },
        { input:{ no: 17, operate: "Stop" }, output:{ no: 17, operate: "Stop" } },
        { input:{ no: 18, operate: "Stop" }, output:{ no: 18, operate: "Stop" } },
        { input:{ no: 19, operate: "Stop" }, output:{ no: 19, operate: "Stop" } },
        { input:{ no: 20, operate: "Stop" }, output:{ no: 20, operate: "Stop" } },
    ],
    result: {},
}
